const ORGANISATION_TYPES = {
  ORG_CLUB: 'Club',
  ORG_LEAGUE: 'League',
  ORG_COMPETITION: 'Competition',
  ORG_FEDERATION: 'Federation',
}

export default ORGANISATION_TYPES
